export default class RejeitarViagemRequest {
    id: number;
    motivo: string;

    constructor(id: number, motivo: string) {
        this.id = id;
        this.motivo = motivo;
    }
}